import * as React from "react";
import "./dropDownList.scss";
import IconLarge from "../../atoms/Icon/IconLarge";
import {Icon} from "../../atoms/Icon/Icon";
import {isNullOrUndefined} from "util";
import classNames = require("classnames");

interface IProps<T> {
	/**
	 * List of items.
	 */
	items: T[];
	/**
	 * Converts item to item label.
	 * @param {T} item
	 * @return {string}
	 */
	itemToLabel: (item: T) => string | JSX.Element;
	/**
	 * Converts item to item id.
	 * @param {T} item
	 * @return {string}
	 */
	itemToId: (item: T) => string;
	/**
	 * Indicates if item is disabled.
	 * @param {T} item
	 * @return {boolean}
	 */
	itemDisabled?: (item: T) => boolean;
	/**
	 * On select callback.
	 * @param {string} id
	 */
	onSelect?: (item: T) => void;
	/**
	 * Selected item id.
	 */
	selectedItemId?: string;
}

export default class DropDownList<T> extends React.PureComponent<IProps<T>, {}> {

	render() {
		return (
			<ul className={"m-dropdown-list"}>
				{this.props.items.map((item, index) => {
					return (
						<li key={index}
							onClick={() => this.onSelect(item)}
							className={classNames({
								"is-selected": this.isItemSelected(item),
								"is-disabled": this.isItemDisabled(item)
							})}>
							{this.props.itemToLabel(item)}
							{this.isItemSelected(item) && <IconLarge icon={Icon.CheckMark}/>}
						</li>
					);
				})}
			</ul>
		);
	}

	/**
	 * On select callback.
	 * @param {T} item
	 */
	onSelect(item: T) {
		if (!isNullOrUndefined(this.props.onSelect) && !this.isItemDisabled(item)) {
			this.props.onSelect(item);
		}
	}

	/**
	 * Indicates if item is selected.
	 * @param {T} item
	 * @return {boolean}
	 */
	isItemSelected(item: T) {
		return this.props.itemToId(item) === this.props.selectedItemId;
	}

	/**
	 * Indicates if item is disabled.
	 * @param {T} item
	 * @return {boolean}
	 */
	isItemDisabled(item: T) {
		return this.props.itemDisabled && this.props.itemDisabled(item);
	}
}

/**
 * Simple dropdown list item.
 */
export interface DropDownItem {
	/**
	 * Identifier for dropdown list item.
	 */
	id: string,
	/**
	 * Label for dropdown list item.
	 */
	label: string,
	/**
	 * Item disable flag.
	 */
	disabled?: boolean
}
